import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-item-view-container',
  imports: [],
  template: ` <div class="item-view-container" [style.marginBottom]="mb()">
    <div class="item-view-label mat-label-small">{{ label() }}</div>
    <div>
      <ng-content></ng-content>
    </div>
  </div>`,
  styles: `
    :host {
      display: block;
    }

    .item-view-container {
      padding: 0.25rem 0.5rem;
      border-left: 1px solid var(--grey-slate-20);
      border-radius: 2px;

      .item-view-label {
        color: var(--text-80-color);
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemViewContainerComponent {
  label = input('');
  mb = input('1.5rem');
}
